
<div *ngIf="comissionerMode == false && showEventsTag == false;" class="container-fluid mt-3 mt-sm-5">
    <div class="row">
        <div class="col-sm-12">
            <div class="banners">
                <swiper [config]="bannersSwiperConfig">
                    <ng-template swiperSlide *ngFor="let banner of banners; let i=index">
                        <app-banner [image]="banner.urlImage" [link]="banner.link" [eventId]="banner.eventId"
                            [slugs]="banner.slugs" [title]="banner.title" [date]="banner.title" [local]="banner.local">
                        </app-banner>
                    </ng-template>

                    <!-- Skeleton -->
                    <ng-template swiperSlide *ngIf="!banners">
                        <app-banner [skeleton]="true"></app-banner>
                    </ng-template>
                    <!-- Skeleton -->

                </swiper>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showClubsShield == false else showClubsShieldTpt">
    <div *ngIf="comissionerMode == false && showEventsTag == false && hideCategoryShowMonth == false"
        class="container-fluid mt-3 mt-sm-5">
        <!-- <div class="row">
            <div class="col-sm-4 mb-3" *ngFor="let category of categories">
                <div class="evcategory__wrapper animate__animated animate__fadeIn" role="button"
                    [class.active]="selectedCategory == category.id" (click)="selectCategory(category.id)">
                    <div class="card">
                        <div class="card-body d-flex align-items-center justify-content-center">
                            <img class="evcategory__icon" [src]="category.icon">
                        </div>
                    </div>
                    <h5 class="evcategory__title">{{ category.name }}</h5>
                </div>
            </div>
        </div> -->
    </div>

    <div *ngIf="hideCategoryShowMonth == true" class="container-fluid mt-3 mt-sm-5">
        <div class="row">
            <div class="col-sm-2 mb-3" *ngFor="let month of months">
                <div class="evcategory__wrapper animate__animated animate__fadeIn" role="button"
                    [class.active]="selectedMonth == month.number" (click)="selectMonth(month.number)">
                    <div class="card text-center w-auto" style="background: rgb(240, 240, 240); color: white;">
                        <div class="d-flex align-items-center text-center justify-content-center">
                            <p class="badge text-fluid text-center text-capitalize badge-gray" style="color: #6b6b6b">{{
                                month["name"] }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #showClubsShieldTpt>
    <div  *ngIf="(pdv$ | async)?.id == '8091d31d-99a9-4383-a208-6b6e9a5f15d6'" class="m-auto w-100 overflow-auto" style="max-width: 1100px;">
        <div class="overflow-auto" style="width: 1091px" *ngIf="hideShields == false">
            <div class="d-flex mt-5 mb-3 overflow-auto justify-content-between h-full w-full">
                <div>
                    <ng-container *ngFor="let team of goianaoTeams">
                        <img [ngStyle]="{'border-top': selectedTeam == team.name ? '5px solid lightblue' : '' }" style="cursor:pointer " [src]="team.image" [class]="team.class" (click)="filterByTeam(team.name)" [width]="team.width" />
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div  *ngIf="(pdv$ | async)?.id == 'e383fdc4-9045-457e-af90-fc4e3b311333'" class="m-auto w-100 overflow-auto" style="max-width: 1100px;">
        <div class="overflow-auto" style="width: 2425px" *ngIf="hideShields == false">
            <div class="d-flex mt-5 mb-3 overflow-auto justify-content-between w-full">
                <div *ngIf="(pdv$ | async)?.id == 'e383fdc4-9045-457e-af90-fc4e3b311333'">
                   <ng-container *ngFor="let team of isaTeams">
                        <img [ngStyle]="{'filter': selectedTeam == team.name ? 'grayscale(100%) contrast(100%) brightness(20%)' : '' }" style="cursor:pointer " [src]="team.image" [class]="team.class" (click)="filterByTeam(team.name)" [width]="team.width" />
                   </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<div class="container-fluid mt-5">
    <div class="row mb-5" *ngIf="hideCategoryShowMonth == false && showClubsShield == false">
        <div class="col-sm-6 col-lg-4 col-xxl-3 my-3" *ngFor="let event of events | filterCategory:selectedCategory">
            <app-card-event *ngIf="event?.id !='f6ae00d6-3f76-4abd-9c03-3676e4e33a38'" [button]="true" [id]="event.id"
                [image]="event.imageWeb" [imagePdv]="event.imagePDV" [name]="event.name" [address]="event.address"
                [showTime]="showTime"
                [utm]="utm"
                [date]="event.dates[0]" [slugs]="event?.slugs" [state]="event.state" [city]="event.city"
                [uf]="event.uf" [redirectToExternalLink]="event?.redirectToExternalLink">
            </app-card-event>
        </div>
        <div *ngIf="(pdv$ | async)?.id != 'c51c9b70-b692-42cb-9821-0945f72f8a2e'">
            <div class="col-sm-12" *ngIf="events?.length === 0 && loading == false">
                <p *ngIf="comissionerMode == false" class="text-grad fs-2 fw-bold text-center">Nenhum evento encontrado</p>
                <p *ngIf="comissionerMode == true" class="text-grad fs-2 fw-bold text-center">Nenhum evento vinculado ao seu usuário</p>
            </div>
        </div>
    </div>
    <div class="row mb-5" *ngIf="hideCategoryShowMonth == false && showClubsShield == true">
        <ng-container *ngIf="(events | filterTeam:selectedTeam).length >=1 else showNoEvents">
            <div class="col-sm-6 col-lg-4 col-xxl-3 my-3" *ngFor="let event of events | filterTeam:selectedTeam">
                <app-card-event *ngIf="event?.id !='f6ae00d6-3f76-4abd-9c03-3676e4e33a38'" [button]="true" [id]="event.id"
                    [image]="event.imageWeb" [utm]="utm"  [showTime]="showTime" [imagePdv]="event.imagePDV" [name]="event.name" [address]="event.address"
                    [date]="event.dates[0]" [slugs]="event?.slugs"  [state]="event.state" [city]="event.city"
                    [uf]="event.uf" [redirectToExternalLink]="event?.redirectToExternalLink">
                </app-card-event>
            </div>
        </ng-container>
        <ng-template #showNoEvents>
            <div class="col-sm-12">
                <p *ngIf="comissionerMode == false" class="text-grad fs-2 fw-bold text-center">Nenhum evento encontrado</p>
                <p *ngIf="comissionerMode == true" class="text-grad fs-2 fw-bold text-center">Nenhum evento vinculado ao seu usuário</p>
            </div>
        </ng-template>     
    </div>
    <div class="row mb-5" *ngIf="hideCategoryShowMonth == true">
        <div class="col-sm-6 col-lg-4 col-xxl-3 my-3" *ngFor="let event of events | filterMonth:selectedMonth">
            <app-card-event *ngIf="event?.id !='f6ae00d6-3f76-4abd-9c03-3676e4e33a38'" [button]="true" [id]="event.id"
                [image]="event.imageWeb" [utm]="utm" [showTime]="showTime" [imagePdv]="event.imagePDV" [name]="event.name" [address]="event.address"
                [date]="event.dates[0]" [slugs]="event?.slugs" [state]="event.state" [city]="event.city"
                [redirectToExternalLink]="event?.redirectToExternalLink" [uf]="event.uf"></app-card-event>
        </div>

        <div>
            <div class="col-sm-12" *ngIf="events?.length === 0 && loading == false">
                <p *ngIf="comissionerMode == false" class="text-grad fs-2 fw-bold text-center">Nenhum evento encontrado</p>
                <p *ngIf="comissionerMode == true" class="text-grad fs-2 fw-bold text-center">Nenhum evento vinculado ao seu usuário</p>
            </div>
        </div>

         <div *ngIf="comissionerMode != true">
            <div class="row mb-5" *ngIf="(pdv$ | async)?.id == 'c51c9b70-b692-42cb-9821-0945f72f8a2e'">
                <div class="col-sm-6 col-lg-4 col-xxl-3 my-3" *ngFor="let event of eventsIsa | filterMonth:selectedMonth">
                    <app-card-event *ngIf="event?.id !='f6ae00d6-3f76-4abd-9c03-3676e4e33a38'" [button]="true" [id]="event.id"
                        [image]="event.image"  [showTime]="showTime"  [name]="event.name" [address]="event.address"
                        [date]="event.date"  [state]="event.state" [city]="event.city"
                        [redirectToExternalLink]="event?.redirectToExternalLink" [uf]="event.uf"></app-card-event>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="pdvLoader$ | async">
        <div class="row mb-5" *ngFor="let sk of [].constructor(3)">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2 m-auto">
                <app-card-category [skeleton]="true"></app-card-category>
            </div>
            <div class="col-sm-12 p-0">
                <swiper class="categories" [config]="categoriesSwiperConfig">
                    <ng-template swiperSlide *ngFor="let sk of [].constructor(5)">
                        <app-card-category [skeleton]="true"></app-card-category>
                    </ng-template>
                </swiper>
            </div>
            <div class="col-sm-6 col-lg-4 col-xxl-3 my-3" *ngFor="let sk of [].constructor(8)">
                <app-card-event [skeleton]="true"></app-card-event>
            </div>
        </div>
    </ng-container>
</div>

<div class="container-fluid bg-grad my-5" *ngIf="showBeOurPartner">
    <div class="d-flex justify-content-center flex-column align-items-center py-5">
        <h4 class="text-white text-center text-uppercase fw-bold m-0 evregtxt">Cadastre seu evento em<br>nossa
            plataforma!</h4>
        <a href="https://docs.google.com/forms/d/16Ws575xORYZUZAxJvONgIr9W-i_dtS_c1GHpC7Ko238/"
            class="btn btn-light btn-lg mt-3" target="_blank">
            <span class="text-grad text-uppercase fw-bold">Seja nosso parceiro</span>
        </a>
    </div>
</div>


<div class="container-fluid mt-5" *ngIf="showSwiperStates">
    <div class="row mb-5">
        <div class="col-sm-12">
            <h2 class="title text-grad">O Que Há em seu estado?</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12" *ngIf="cities$ | async as cities">
            <app-swiper-cities (sendSelectedState)="setSelectedState($event)" [cities]="cities"></app-swiper-cities>
        </div>
    </div>
</div>